import { render, staticRenderFns } from "./Criticism.vue?vue&type=template&id=17a3aafd"
import script from "./Criticism.vue?vue&type=script&lang=js"
export * from "./Criticism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports